import { render, staticRenderFns } from "./Podcast.vue?vue&type=template&id=3bab4984&scoped=true&"
import script from "./Podcast.vue?vue&type=script&lang=js&"
export * from "./Podcast.vue?vue&type=script&lang=js&"
import style0 from "./Podcast.vue?vue&type=style&index=0&id=3bab4984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab4984",
  null
  
)

export default component.exports